
const imageUrl = (title) => {
  return `/imgs/wms/${title}.png`;
};

const banner = {
  title: '仓储管理系统（WMS）',
  description: '云恋科技仓储管理系统（WMS）是集成了不同行业最佳实践业务模型，专门为物流园区、第三方物流企业、制造企业等配送中心和仓库提供高效率、一体化、协同化的B2B仓储管理解决方案。',
  img: imageUrl('banner')
};

const feature = [
  {
    title: '场景丰富',
    items: [
      '提供多行业（批发业、零售业、生产制造业、B2B电商）、多层级、多仓库、多货主的网络化仓储解决方案。',
    ]
  },
  {
    title: '全程可视',
    items: [
      '实现仓储订单履约全流程、供应链库存透明化、可视化的管理。',
    ]
  },
  {
    title: '流程极简',
    items: [
      '根据不同规模、不同行业的B2B业务场景，在订单处理、入库流程、出库流程、库内处理等业务流程灵活配置，简化业务流程，实现快进快出，提高效率。',
    ]
  },
  {
    title: '性价比高',
    items: [
      'SaaS系统可快速部署，操作简单，上手快，易用性强，低投入，高回报。',
    ]
  }
];

const func = [
  {
    title: '基础设置',
    img: imageUrl('func1'),
    description: '建立客户档案 、产品档案、库房、库区 、库位、业务规则等基础信息'
  },
  {
    title: '入库管理',
    img: imageUrl('func2'),
    description: '预约管理、快捷收货、标准收货、质检、上架'
  },
  {
    title: '库存管理',
    img: imageUrl('func3'),
    description: '库存查询、库存移库、库存冻结、库存盘点、库存调整'
  },
  {
    title: '出库处理',
    img: imageUrl('func4'),
    description: '订单分配、创建波次、拣货、出库复核、装车发运'
  },
  {
    title: '增值服务',
    img: imageUrl('func5'),
    description: '支持库内贴标、换包装、组装和拆装等增值服务'
  },
  {
    title: '任务中心',
    img: imageUrl('func6'),
    description: '支持人工指定或自动下发任务，撤销任务，取消任务，任务完成进度管理、增值任务'
  },
  {
    title: '报表中心',
    img: imageUrl('func7'),
    description: '支持标准入库、出库、库存明细报表，自定义报表，KPI管理'
  },
  {
    title: '规则管理',
    img: imageUrl('func8'),
    description: '收货策略、质检策略、上架策略 、补货策略、分配策略、盘点策略、批次属性管理'
  },
  {
    title: '可视化看板',
    img: imageUrl('func9'),
    description: '支持大屏显示，实时展示车辆状态、运力分布、订单执行进度'
  },
  {
    title: '系统集成',
    img: imageUrl('func10'),
    description: '支持RF、扫描枪、电子称等仓库操作设备进行无缝集成'
  },
];

const structure = imageUrl('structure');

export {banner, feature, func, structure};


// WEBPACK FOOTER //
// ./src/routes/ProductWMS/config.js